<template>
  <transition-group name="fade-list" tag="span" appear>
    <slot />
  </transition-group>
</template>

<script>
export default {}
</script>

<style>
.fade-list-enter-active,
.fade-list-leave-active {
  transition: var(--default-fade-transition);
}
.fade-list-enter-from,
.fade-list-leave-to {
  opacity: 0;
}
</style>
